const polyfill = function () {
    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params = { bubbles: false, cancelable: false, detail: null }) {
        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    window.CustomEvent = CustomEvent;
    return true;
};
polyfill();

const bodyElement = document.querySelector('body');
const eventName = 'unactioned-items-change';

export function handleUnactionedDocketsEvent(handler) {
    bodyElement.addEventListener(
        eventName,
        ev => {
            handler(ev.detail);
        }
    );
}

export function dispatchUnactionedDocketsEvent(detail) {
    const event = new CustomEvent(eventName, { detail });
    bodyElement.dispatchEvent(event);
}
